var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Offene Redebox")]),_c('SpeechBox',{attrs:{"speakers":_vm.$store.state.openSpeakers}}),_c('h2',[_vm._v("Quotierte Redebox")]),_c('SpeechBox',{attrs:{"speakers":_vm.$store.state.quotedSpeakers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }